import React from 'react';

/** Trust strip — source: mockup L290–300 (real clubs only; grey placeholders omitted). */
const TrustStrip = (): React.JSX.Element => (
  <section className="oq-trust">
    <div className="oq-trust__inner">
      <span className="oq-trust__label oq-bebas">TRUSTED BY UK ENDURANCE &amp; MULTISPORT CLUBS</span>
      <div className="oq-trust__club">
        <img src="/images/badtri.png" alt="BADTri" width={30} height={30} className="oq-trust__club-logo" />
        <span className="oq-trust__wordmark oq-bebas">BADTRI</span>
      </div>
      <span className="oq-trust__wordmark oq-bebas">3CTRI</span>
    </div>
  </section>
);

export default TrustStrip;
